var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _circle4, _circle5, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 690 449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M212 420c4-10 9-20 11-31s1-23-4-32-18-16-29-14c-9 2-16 9-20 17s-6 17-7 26c-1-10-2-21-5-30s-10-19-20-23-21 0-26 9c-7 12 2 30-6 42-2-12-14-22-26-20s-21 15-18 27c1 7 6 13 12 17s12 9 19 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 373c9 3 19 6 28 11 7 5 14 11 18 19a33 33 0 0 1 5 14h1c0-9-5-17-11-24-7-7-15-12-24-16l-17-6v2Zm54-38a143 143 0 0 1 14 31 145 145 0 0 1 6 33 143 143 0 0 1 1 18h1a145 145 0 0 0-2-33 147 147 0 0 0-10-33 143 143 0 0 0-8-17 1 1 0 0 0-2 1Zm78 9a232 232 0 0 0-17 58l-2 17h2a231 231 0 0 1 12-58l7-16c0-1-1-2-2-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M482 432v10h-47v-10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M499 444h-7l-4-7 5-8h6a12 12 0 1 0 0 15Zm-80 0h7l4-7-4-8h-7a12 12 0 1 1 0 15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M689 421H1a1 1 0 0 1 0-2h688a1 1 0 0 1 0 2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540.5,
    cy: 198,
    r: 33,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m554 383 2 12 48-4-4-18-46 10z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m550 421-8-38 15-3 5 23a15 15 0 0 1-12 18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m524 383-5 11-45-16 8-16 42 21z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m512 400 10-21 14 6-17 35a15 15 0 0 1-7-20Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M435 361a11 11 0 0 0 13-11l74-68-18-15-67 72a11 11 0 0 0-2 22Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.3,
    cy: 207.9,
    r: 24.6,
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M558 352c-17 0-38-3-50-18l-1-1h1s9-11 0-30l-13 4-13-17 7-21 29-24a27 27 0 0 1 15-6 80 80 0 0 0 28-8 28 28 0 0 1 12-2h1a10 10 0 0 1 10 10c-2 26-6 88 4 109l1 1h-1a136 136 0 0 1-30 3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M511 333s-65-6-72 13 1 28 13 32 41 9 41 9l13-16 34 2s38 22 48 46a31 31 0 0 0 26 18c9 1 16-2 16-16 0-30-42-73-42-73Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M461 363s17-5 44 8m7-179a73 73 0 0 0 31 11l-3-4a24 24 0 0 0 8 1 8 8 0 0 0 6-3 8 8 0 0 0 1-7 15 15 0 0 0-5-6 27 27 0 0 0-25-4 16 16 0 0 0-8 4 9 9 0 0 0-2 9m25-20a75 75 0 0 1 19-27c6-5 12-9 19-10s15 1 19 7c4 4 4 10 4 16l-2 17a35 35 0 0 0 51 32c-6 3-11 8-17 12s-13 7-19 5c-7-3-10-11-12-18l-11-30c-2-6-4-11-7-15s-10-7-15-5c-4 2-7 6-9 9s-4 8-8 9-9 1-11-3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m533 328 7-7 33 33-7 7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M567 354a10 10 0 1 0 13 0 10 10 0 0 0-13 0Zm10 10a4 4 0 1 1 0-6 4 4 0 0 1 0 6Zm-48-56 5 5-2 8-8 2-5-5a12 12 0 1 0 10-10Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M549 352a12 12 0 0 1-2 0 11 11 0 0 1-9-9 11 11 0 0 1 11-13 11 11 0 0 1 1 0l34-35-4-12 18-8 5 12a20 20 0 0 1-6 24l-37 29a10 10 0 0 1 0 1 11 11 0 0 1-4 9 11 11 0 0 1-7 2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M575 233a9 9 0 0 1 13 6l17 43-27 18Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M448 244V25a25 25 0 0 0-25-25H80a25 25 0 0 0-25 25v219a25 25 0 0 0 25 25h343a25 25 0 0 0 25-25ZM80 266a22 22 0 0 1-22-22V25A22 22 0 0 1 80 3h343a22 22 0 0 1 23 22v219a22 22 0 0 1-23 22Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M446 39H58a1 1 0 1 1 0-3h388a1 1 0 0 1 0 3Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.9,
    cy: 20.8,
    r: 7.4,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.2,
    cy: 20.8,
    r: 7.4,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 20.8,
    r: 7.4,
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189 199a1 1 0 0 1-1-1c0-10-5-16-12-22a1 1 0 1 1 1-2c8 7 13 13 13 24a1 1 0 0 1-1 1Zm-86 0a1 1 0 0 1-1-1c0-11 5-17 13-24a1 1 0 1 1 1 2c-7 6-12 12-12 22a1 1 0 0 1-1 1Zm77-68a1 1 0 0 1 0-2c7-6 8-15 8-25a1 1 0 0 1 2 0c0 11-1 20-9 26a1 1 0 0 1-1 1Zm-68-1a1 1 0 0 1-1 0c-8-7-9-16-9-26a1 1 0 0 1 2 0c0 10 1 18 9 24a1 1 0 0 1-1 2Zm90 22h-22a1 1 0 0 1 0-2h22a1 1 0 1 1 0 2Zm-90 0H90a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2Zm34 43a1 1 0 0 1-1-1v-69a1 1 0 0 1 2 0v69a1 1 0 0 1-1 1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146 195a35 35 0 0 1-35-35v-26c0-17 13-27 35-27 23 0 35 10 35 27v26a35 35 0 0 1-35 35Zm0-86c-16 0-33 7-33 25v26a33 33 0 1 0 66 0v-26c0-22-20-25-33-25Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126 113a1 1 0 0 1-1 0 14 14 0 0 1-1-5 22 22 0 0 1 22-22 22 22 0 0 1 23 22 12 12 0 0 1-1 4 1 1 0 0 1-2 0 10 10 0 0 0 1-4 20 20 0 0 0-21-20 20 20 0 0 0-20 20 12 12 0 0 0 1 4 1 1 0 0 1-1 1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M248 108h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14Zm82 30h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14Zm38 0h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14Zm38 0h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14Zm-75-29h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14Zm-39 28h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14Zm110-28h-43a7 7 0 0 1 0-14h43a7 7 0 0 1 0 14Zm-154 58h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14Zm83 1h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14Zm71 0h-43a7 7 0 0 1 0-14h43a7 7 0 0 1 0 14Zm-19 23a7 7 0 0 1 7-7h12a7 7 0 0 1 0 14h-12a7 7 0 0 1-7-7Zm-83 1a7 7 0 0 1 7-7h56a7 7 0 0 1 0 14h-56a7 7 0 0 1-7-7Zm-71 0a7 7 0 0 1 7-7h43a7 7 0 0 1 0 14h-43a7 7 0 0 1-7-7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.aab1412955b1faffa354764d524076f8.svg";
export { ForwardRef as ReactComponent };